import { Divider, VStack, DataList } from '@cad-arc';
import { EventSearchInvolvedItemForm } from '@mark43/cad-api';
import { intersperse } from '../common/helpers/intersperse';
import { FilterSummary } from './filter-summary';
import { FiltersSummary } from './filters-summary';

export function InvolvedItemsInformationFiltersSummary({
    involvedItems,
}: {
    involvedItems: EventSearchInvolvedItemForm[];
}) {
    if (involvedItems.length === 0) {
        return null;
    }
    return (
        <FiltersSummary title="Involved Property Information">
            <VStack align="left" gap="2px">
                {intersperse(
                    involvedItems.map((item, index) => (
                        <DataList key={index}>
                            <FilterSummary label="Property Type" option={item.propertyType} />
                            <FilterSummary
                                label="Property Category"
                                option={item.propertyCategory}
                            />
                            <FilterSummary label="Color" option={item.color} />
                            <FilterSummary label="Serial Number" stringValue={item.serialNumber} />
                            <FilterSummary label="Firearm Make" option={item.firearmMake} />
                            <FilterSummary label="Firearm Model" stringValue={item.model} />
                            <FilterSummary label="Description" stringValue={item.description} />
                        </DataList>
                    )),
                    <Divider />
                )}
            </VStack>
        </FiltersSummary>
    );
}
